<template>
    <div class="c-accordion" v-if="loaded">
        <div v-for="(item,key) in currentTrim.description_extended" :key="key" class="c-accordion__item" :class="{'-is-active': isActive(key)}">
            <div class="c-accordion__header" @click="toggle(key)">
                <h2 class="c-accordion__title">{{item.titre}}</h2>
                <svgIco icon="arrow-down" />
            </div>
            <div class="c-accordion__content">
                <div class="c-accordion__inner">
                    <div class="o-text" v-html="toUlLi(item.description)"></div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'NewCarSpecs',
    data() {
        return {
           currentTrim: {},
           loaded: false,
           active:[]
        }
    },
    methods: {
        isActive(key) {
            return this.active[key];
        },
        toggle(key) {
            this.active[key] = !this.active[key];
        },
        toUlLi(str) {
            return '<ul><li>'+str.replace(/(?:\r\n|\r|\n)/g, '</li><li>')+'</li></ul>';
        },
        bind() {
            document.$on('trimChanged', (data) => {
                console.log(data.detail.trim);
                this.currentTrim = data.detail.trim;
                this.loaded = true;
            });
        } 
    },
    mounted() {
        this.bind();
    }
}
</script>